const Footer = () => {
  return (
    <footer className="text-center p-8 mt-8 border-t dark:border-gray-500 border-gray-300">
      Ähli hukuklar goragly &copy;{new Date().getFullYear()}
    </footer>
  );
};

export default Footer;
